import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import CheatSheetGenerator from './CheatSheetGenerator';
import './App.css';
import { Navigation } from "./React-Landing-Page-Template/src/components/navigation";
import { Header } from "./React-Landing-Page-Template/src/components/header";
import { About } from "./React-Landing-Page-Template/src/components/about";
import { Team } from "./React-Landing-Page-Template/src/components/Team";
import { Testimonials } from "./React-Landing-Page-Template/src/components/testimonials";
import { Contact } from "./React-Landing-Page-Template/src/components/contact";
import Divider from "./React-Landing-Page-Template/src/components/Divider";
import JsonData from "./React-Landing-Page-Template/src/data/data.json";
import SmoothScroll from "smooth-scroll";
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import { Analytics } from "@vercel/analytics/react";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 300,
  speedAsDuration: true,
  easing: 'easeOutQuad'
});

function App() {
  const [landingPageData, setLandingPageData] = useState({});
  
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={
          <div>
            <Navigation />
            <Header data={landingPageData.Header} />
            <About data={landingPageData.About} />
            <Divider />
            <Team data={landingPageData.Team} />
            <Testimonials data={landingPageData.Testimonials} />
            <Contact data={landingPageData.Contact} />
          </div>
        } />
        <Route 
          path="/cheatsheet" 
          element={
            <ProtectedRoute>
              <CheatSheetGenerator />
            </ProtectedRoute>
          } 
        />
      </Routes>
      <Analytics />
    </AuthProvider>
  );
}

export default App;